import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeFromNowPipe } from './time-from-now.pipe';

@NgModule({
  declarations: [TimeFromNowPipe],
  imports: [CommonModule],
  exports: [TimeFromNowPipe],
})
export class TimeFromNowPipeModule {}
